import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';

const SuccessPage = () => {
  const [searchParams] = useSearchParams();
  const [sessionId, setSessionId] = useState(null);

  useEffect(() => {
    const session = searchParams.get('session_id');
    if (session) {
      console.log('Stripe session ID:', session);
      setSessionId(session);
    }

    console.log('Success page loaded');
    console.log('Current URL:', window.location.href);
  }, [searchParams]);

  return (
    <div className="flex justify-center items-center min-h-[80vh] bg-background">
      <div className="bg-surface p-10 rounded-2xl text-center max-w-md shadow-elevated border border-sage-100">
        <div className="text-6xl text-sage-500 mb-5">✓</div>
        <h1 className="text-charcoal text-2xl font-display mb-2">Payment Successful!</h1>
        <p className="text-gray-500 leading-relaxed">Your FoodLens Premium subscription is now active.</p>
        <p className="text-gray-500 leading-relaxed mt-2">You now have access to:</p>

        <ul className="text-left text-gray-500 my-5 space-y-2">
          <li className="flex items-center gap-2">
            <span className="text-sage-500">✓</span>
            All 7 ingredient lenses
          </li>
          <li className="flex items-center gap-2 opacity-50">
            <span className="text-sage-500">✓</span>
            Unlimited custom lenses
            <span className="bg-sage-100 text-sage-600 px-2 py-0.5 rounded text-xs font-medium uppercase">
              Coming Soon
            </span>
          </li>
          <li className="flex items-center gap-2">
            <span className="text-sage-500">✓</span>
            10,000 requests per month
          </li>
          <li className="flex items-center gap-2">
            <span className="text-sage-500">✓</span>
            Priority support
          </li>
        </ul>

        <Link
          to="/"
          className="btn-primary mt-5"
        >
          Continue to FoodLens
        </Link>
      </div>
    </div>
  );
};

export default SuccessPage;
